import React from "react";

/** Atoms */
import { Loading } from "@atoms/index";

/** Libraries */
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Checkbox
} from "@libraries/mui";

/** Graphql */
import { ContractType } from "@graphql/helpers/types.graphql";

// Language
import { BaseCardMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";

/** Styled components */
import * as Styled from "./styles";

interface Props {
  loading: boolean;
  contracts: ContractType[];
  setSelectedContracts: React.Dispatch<React.SetStateAction<ContractType[]>>;
  selectedContracts: ContractType[];
}

const LinkContractList: React.FC<Props> = ({
  loading,
  contracts,
  setSelectedContracts,
  selectedContracts
}) => {
  const { t } = useTranslation();
  const handleToggle = (contract: ContractType) => () => {
    const currentIndex = selectedContracts.indexOf(contract);
    const newSelectedContracts = [...selectedContracts];

    if (currentIndex === -1) {
      newSelectedContracts.push(contract);
    } else {
      newSelectedContracts.splice(currentIndex, 1);
    }

    setSelectedContracts(newSelectedContracts);
  };

  return (
    <Styled.Container>
      {loading ? (
        <Loading />
      ) : (
        <List
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            maxHeight: 250
          }}
        >
          {contracts.map((contract) => {
            const labelId = `checkbox-list-label-${contract.id}`;

            const addressFormated = `${contract.construction?.address}, ${
              contract.construction?.number
                ? contract.construction?.number
                : "S/N"
            } ${
              contract.construction?.complement
                ? `, ${contract.construction.complement}`
                : ""
            } ${
              contract.construction?.county
                ? `, ${contract.construction?.county}`
                : ""
            }`;

            return (
              <ListItem key={contract.id} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={handleToggle(contract)}
                  dense
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Styled.CustomCheckbox
                      edge="start"
                      checked={selectedContracts.indexOf(contract) !== -1}
                      tabIndex={-1}
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <Styled.ItemContent>
                    <div className="titleHeader">
                      {contract.construction?.name}
                    </div>
                    <div>{addressFormated}</div>
                    {contract.construction?.client?.name && (
                      <div>
                        <span className="titleContent">
                          {t(BaseCardMessages.permissionClientNameText)}:{" "}
                        </span>{" "}
                        {contract.construction.client.name}
                      </div>
                    )}
                    <div>
                      <span className="titleContent">
                        {t(BaseCardMessages.contractLabelText)}:{" "}
                      </span>{" "}
                      {contract.code}
                      &nbsp;&nbsp;&nbsp;
                      <span className="titleContent">
                        {t(BaseCardMessages.contractDateText)}:{" "}
                      </span>{" "}
                      {new Date(contract.contractDate).toLocaleDateString()}
                    </div>
                  </Styled.ItemContent>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      )}
    </Styled.Container>
  );
};

export default LinkContractList;
